<template>
<!-- eslint-disable max-len -->
<div
  class="tooltip-root"
  :style="rootStyle"
>
  <transition
    :enter-active-class="disableEnterTransition ? '' : 'animated fadeIn'"
    :leave-active-class="disableExitTransition ? '' : 'animated fadeOut'"
  >
    <div v-if="showHighlight"
      :id="highlightId"
      class="highlight"
      :class="`${textPosition}`"
      :style="highlightStyle"
      @click="onClickHighlight"
    >
      <div
        v-if="showHighlight"
        ref="tooltipTextContainer"
        class="tooltip-text-container"
        :class="`${textPosition}`"
        :style="tooltipStyle"
        @click="onClickTooltip"
      >
        <span v-html="tooltip ? tooltip.text : ''"></span>
        <div
          class="tooltip-text-container-tail"
          :class="`${textPosition}`"
          :style="tooltipTailStyle"
        ></div>
      </div>
    </div>
  </transition>
  <!--
  <b-tooltip
    v-if="showHighlight"
    :target="highlightId"
    :placement="tooltip ? tooltip.textPosition : 'top'"
    triggers=""
    :show="showTooltip"
    :boundary="target === 'progressBar' ? undefined : 'viewport'"
  >
    <span
      v-html="tooltip ? tooltip.text : ''"
      @click="onClickTooltip"
    ></span>
  </b-tooltip>
  -->
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    target: { type: String, default: '' },
    disableEnterTransition: { type: Boolean, default: false },
    disableExitTransition: { type: Boolean, default: false },
  },
  data() {
    return {
      showHighlight: false,
      showTooltip: false,
    };
  },
  computed: {
    ...mapGetters([
      'tooltip',
    ]),
    targetMatch() {
      // console.log(this.tooltip);
      return this.tooltip && (this.target === this.tooltip.target || !(this.target) && this.tooltip.target == null);
    },
    textPosition() {
      return (this.tooltip && this.tooltip.textPosition) ? this.tooltip.textPosition : 'top';
    },
    highlightId() {
      return `tooltip-${this.target}-highlight`;
    },
    highlightStyle() {
      return !(this.tooltip) ? {} : {
        height: this.tooltip.highlightHeight || '100%',
        width: this.tooltip.highlightWidth || '100%',
        outline: this.tooltip.highlightBorder ? this.tooltip.highlightBorder : undefined,
        'border-radius': this.tooltip.highlightBorderRadius ? this.tooltip.highlightBorderRadius : undefined,
        'background-color': this.tooltip.highlightColor || 'rgba(231, 154, 21, 0.25)',
        position: (this.tooltip.highlightXOffset || this.tooltip.highlightYOffset) ? 'relative' : undefined,
        bottom: this.tooltip.highlightYOffset ? this.tooltip.highlightYOffset : undefined,
        left: this.tooltip.highlightXOffset ? this.tooltip.highlightXOffset : undefined,
        'pointer-events': (this.tooltip.requireClickOnHighlight || this.tooltip.highlightBlocksClick) ? 'auto' : 'none',
      };
    },
    tooltipStyle() {
      return !(this.tooltip) ? {} : {
        'background-color': (this.tooltip.textBackgroundColor ? this.tooltip.textBackgroundColor : 'black'),
        margin: this.tooltip.highlightBorder ? '9px' : undefined,
        width: !(this.tooltip.textWidth) ? this.tooltip.textWidth : undefined,
        'min-width': (this.tooltip.textWidth)
          ? this.tooltip.textWidth
          : (!(this.tooltip.text)
            ? undefined
            : (this.tooltip.text.length > 30
              ? '285px'
              : (this.tooltip.text.length > 12
                ? '185px'
                : undefined))),
      };
    },
    tooltipTailStyle() {
      return !(this.tooltip) ? {} : {
        'background-color': (this.tooltip.textBackgroundColor ? this.tooltip.textBackgroundColor : 'black'),
      };
    },
    rootStyle() {
      return !(this.tooltip) ? {} : {
        'min-height': this.tooltip.highlightHeight || '100%',
        'min-width': this.tooltip.highlightWidth || '100%',
      };
    },
  },
  methods: {
    ...mapActions([
      'advanceTooltip',
      'playVoice',
      'stopLastTooltipVoiceIfPlaying',
    ]),
    async onClick() {
      if (!this.disableExitTransition) {
        this.stopLastTooltipVoiceIfPlaying();
        this.showTooltip = false;
        await new Promise(resolve => setTimeout(resolve, 200));
        this.showHighlight = false;
        await new Promise(resolve => setTimeout(resolve, 250));
      }
      // console.log('tooltip click');
      this.advanceTooltip();
    },
    async onClickHighlight(ev) {
      if (this.tooltip.highlightBlocksClick) {
        ev.preventDefault();
        ev.stopPropagation();
      }
      if (this.tooltip.requireClickOnHighlight || this.tooltip.highlightBlocksClick) {
        await this.onClick();
      }
    },
    async onClickTooltip(ev) {
      if (this.tooltip.allowClickOnTooltip) {
        await this.onClickHighlight(ev);
      }
    },
    async onClickAnywhere() {
      if (this.tooltip && this.targetMatch && !(this.tooltip.requireClickOnHighlight)) {
        await this.onClick();
      }
    },
  },
  watch: {
    async targetMatch(newMatch, oldMatch) {
      if (newMatch && !oldMatch) {
        window.removeEventListener('click', this.onClickAnywhere);
        window.addEventListener('click', this.onClickAnywhere);
        this.showHighlight = true;
        await new Promise(resolve => setTimeout(resolve, 100));
        if (!(this.showTooltip) && this.tooltip && this.tooltip.textVoiceLine) {
          this.playVoice({ line: this.tooltip.textVoiceLine, next: '', tooltip: true });
        }
        this.showTooltip = true;
      } else if (oldMatch && !newMatch) {
        this.stopLastTooltipVoiceIfPlaying();
        this.showTooltip = false;
        this.showHighlight = false;
      }
    }
  },
  async mounted() {
    if (this.tooltip && this.targetMatch) {
      window.removeEventListener('click', this.onClickAnywhere);
      window.addEventListener('click', this.onClickAnywhere);
      this.showHighlight = true;
      await new Promise(resolve => setTimeout(resolve, 100));
      if (!(this.showTooltip) && this.tooltip && this.tooltip.textVoiceLine) {
        this.playVoice({ line: this.tooltip.textVoiceLine, next: '', tooltip: true });
      }
      this.showTooltip = true;
    }
  },
  beforeDestroy() {
    this.stopLastTooltipVoiceIfPlaying();
    window.removeEventListener('click', this.onClickAnywhere);
  }
};
</script>

<style lang="scss" scoped>
.tooltip-root {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  bottom: 0;
  pointer-events: none;
}
.highlight {
  z-index: 10000;
  pointer-events: auto;
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
}
.highlight.right {
  flex-flow: row nowrap;
}
.highlight.righttop {
  flex-flow: row nowrap;
}
.highlight.rightbottom {
  flex-flow: row nowrap;
}
.highlight.left {
  flex-flow: row-reverse nowrap;
}
.highlight.lefttop {
  flex-flow: row-reverse nowrap;
}
.highlight.leftbottom {
  flex-flow: row-reverse nowrap;
}
.highlight.top {
  flex-flow: column-reverse nowrap;
}
.highlight.topleft {
  flex-flow: column-reverse nowrap;
  align-items: flex-end;
}
.highlight.topright {
  flex-flow: column-reverse nowrap;
}
.highlight.bottom {
  flex-flow: column nowrap;
}
.highlight.bottomleft {
  flex-flow: column nowrap;
}
.highlight.bottomright {
  flex-flow: column nowrap;
}
.tooltip-text-container {
  z-index: 10000;
  position: relative;
  color: white;
  background-color: black;
  border-radius: 5px;
  font-size: 16.5px;
  line-height: 126%;
  padding: 4px 8px;
  max-width: 330px;
  margin: 5px;
}
.tooltip-text-container.right {
  left: 100%;
}
.tooltip-text-container.righttop {
  left: 100%;
  top: -25%;
}
.tooltip-text-container.rightbottom {
  left: 100%;
  top: 25%;
}
.tooltip-text-container.left {
  right: 100%;
}
.tooltip-text-container.lefttop {
  right: 100%;
  top: -25%;
}
.tooltip-text-container.leftbottom {
  right: 100%;
  top: 25%;
}
.tooltip-text-container.top {
  bottom: 100%;
}
.tooltip-text-container.topleft {
  bottom: 100%;
  right: 25%;
}
.tooltip-text-container.topright {
  bottom: 100%;
  right: -25%;
}
.tooltip-text-container.bottom {
  top: 100%;
}
.tooltip-text-container.bottomleft {
  top: 100%;
  right: 25%;
}
.tooltip-text-container.bottomright {
  top: 100%;
  right: -25%;
}
.tooltip-text-container-tail {
  z-index: 9999;
  position: absolute;
  background-color: black;
  transform: rotate(45deg);
  width: 10px;
  height: 10px;
  margin: -5px;
}
.tooltip-text-container-tail.right {
  right: 100%;
  top: 50%;
}
.tooltip-text-container-tail.righttop {
  right: 100%;
  bottom: 11px;
}
.tooltip-text-container-tail.rightbottom {
  right: 100%;
  top: 11px;
}
.tooltip-text-container-tail.left {
  left: 100%;
  top: 50%;
}
.tooltip-text-container-tail.lefttop {
  left: 100%;
  bottom: 11px;
}
.tooltip-text-container-tail.leftbottom {
  left: 100%;
  top: 11px;
}
.tooltip-text-container-tail.top {
  top: 100%;
  right: 50%;
}
.tooltip-text-container-tail.topleft {
  top: 100%;
  right: 11px;
}
.tooltip-text-container-tail.topright {
  top: 100%;
  left: 11px;
}
.tooltip-text-container-tail.bottom {
  bottom: 100%;
  right: 50%;
}
.tooltip-text-container-tail.bottomleft {
  bottom: 100%;
  right: 11px;
}
.tooltip-text-container-tail.bottomright {
  bottom: 100%;
  left: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/Tooltip.vue